import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCustomerQuery,
  useUpdateCustomerMutation,
} from "../../services/customerApi";
import CustomergroupSelect from "../Common/CustomSelect/CustomergroupSelect";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";

const UpdateCustomer = () => {
  const { id } = useParams();
  const auth = signInUser();
  const { aamarId } = auth;
  // console.log("Customer ID", id);
  let navigate = useNavigate();
  // const { data, error, isLoading, isFetching, isSuccess } =
  //   useCustomerQuery({id});
  const { data, error, isLoading, isSuccess } = useCustomerQuery({
    id,
    aamarId,
  });

  console.log("customer data", data);
  // console.log("Customer DATA ::>", data);

  const { register, handleSubmit, reset, watch, getValues, setValue } = useForm(
    {}
  );
  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);
  const [group, setGroup] = useState("");
  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data, isSuccess]);
  const handleSelectGroup = (e) => {
    console.log("Selected Option:", e);

    // Safely handle the case when e is null or no-Group
    if (e && e.value && e.value !== "no-Group") {
      setGroup(e.value); // Update group with the selected value
      setValue("group", e.value, {
        shouldValidate: true,
        shouldDirty: true,
      });
    } else {
      setGroup(null); // Reset group if no option is selected
      setValue("group", null, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    if (data) {
      reset({
        _id: data?._id,
        name: data?.name,
        phone: data?.phone,
        email: data?.email,

        addressType: data?.address[0]?.type,
        holdingNo: data?.address[0]?.holdingNo,
        sector: data?.address[0]?.sector,
        street: data?.address[0]?.street,
        town: data?.address[0]?.town,
        city: data?.address[0]?.city,
        division: data?.address[0]?.division,
        country: data?.address[0]?.country,
        zipCode: data?.address[0]?.zipCode,

        membership: data?.membership,
        point: data?.point,
        type: data?.type,
        status: data?.status,
        group: data?.group?.id,
        batch: data?.batch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data]);

  // handel user update
  const [UpdateCustomer] = useUpdateCustomerMutation();

  const updateHandler = async (customer) => {
    // console.log("customer", customer);
    setLoader(true);
    let newCustomer = {};
    if (customer.password === customer.rePassword) {
      newCustomer = {
        _id: data?._id,
        name: customer?.name,
        password: customer.password === "" ? customer?.password : data.password,
        phone: customer?.phone,
        email: customer?.email,
        membership: customer?.membership,
        group:
          customer?.group && customer?.group !== "no-Group"
            ? customer?.group
            : null,
        batch: customer?.batch,
        address: [
          {
            type: data?.address[0]?.type ? data?.address[0]?.type : "Home",
            holdingNo: customer?.holdingNo,
            sector: customer?.sector,
            street: customer?.street,
            town: customer?.town,
            city: customer?.city,
            division: customer?.division,
            country: customer?.country,
            zipCode: customer?.zipCode,
          },
        ],
        point: data?.point ? data?.point : 0,
        type: customer?.type,
        status: customer?.status,
      };
      console.log("customer new", newCustomer);

      const response = UpdateCustomer(newCustomer);
      if (response) {
        setLoader(false);

        notify("Update Customer Profile Successful", "success");
        navigate("/customer");
      } else {
        setLoader(false);
        notify("Customer Profile Update Field", "error");
      }
      // console.log("newCustomer", newCustomer);
    } else {
      notify("Password does not matched", "error");
    }

    setLoader(false);
  };

  // console.log(data);
  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={`Update Customer: ${data?.name}`}></Header>
            <div className="row  mt-3 pt-3 pb-5">
              <div className="col-md-6 offset-md-3">
                <form onSubmit={handleSubmit(updateHandler)}>
                  <h6 className="mb-2">
                    <Icons.UserOutline size={20} /> Basic Info
                  </h6>
                  <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        {...register("name", { required: true })}
                        placeholder="Name"
                      />
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        {...register("email")}
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label className="col-sm-3 col-form-label">Phone</label>
                    <div className="col-sm-9">
                      <input
                        {...register("phone")}
                        type="phone"
                        className="form-control"
                        id="phone"
                        placeholder="phone"
                      />
                    </div>
                  </div>
                  <h6 className="mb-2 mt-4">
                    <Icons.LocationMarkerOutline size={20} /> Address
                  </h6>
                  <div className="row">
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">House</label>
                      <input
                        {...register("holdingNo")}
                        type="text"
                        className="form-control"
                        id="holdingNo"
                        placeholder="House"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">street</label>
                      <input
                        {...register("street")}
                        type="text"
                        className="form-control"
                        id="street"
                        placeholder="street"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">Sector</label>
                      <input
                        {...register("sector")}
                        type="text"
                        className="form-control"
                        id="sector"
                        placeholder="Sector"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">Town</label>
                      <input
                        {...register("town")}
                        type="text"
                        className="form-control"
                        id="town"
                        placeholder="Town"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">City</label>
                      <input
                        {...register("city")}
                        type="text"
                        className="form-control"
                        id="city"
                        placeholder="City"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">Division</label>
                      <input
                        {...register("division")}
                        type="text"
                        className="form-control"
                        id="division"
                        placeholder="Division"
                      />
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="MCId">Zip Code</label>
                      <input
                        {...register("zipCode")}
                        type="text"
                        className="form-control"
                        id="zipCode"
                        placeholder="Zip code"
                      />
                      zipcode
                    </div>
                    <div className="form-group col-8  mb-3">
                      <label htmlFor="MCId">Country</label>
                      <input
                        {...register("country")}
                        type="text"
                        className="form-control"
                        id="country"
                        placeholder="Country"
                      />
                    </div>
                  </div>
                  <h6 className="mb-2 mt-4">
                    <Icons.ShieldCheckOutline size={20} /> Security
                  </h6>

                  <div className="form-group row mb-2">
                    <label
                      for="staticEmail"
                      className="col-sm-2 col-form-label"
                    >
                      Username
                    </label>
                    <div className="col-sm-10 ">
                      <input
                        type="text"
                        readonly
                        className="form-control-plaintext"
                        id="staticEmail"
                        value={data?.username}
                      />
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label
                      for="inputPassword"
                      className="col-sm-2 col-form-label"
                    >
                      Password
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="password"
                        className="form-control"
                        id="inputPassword"
                        {...register("password")}
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div className="form-group row mb-2">
                    <label
                      for="inputPassword"
                      className="col-sm-2 col-form-label"
                    >
                      Confirm Password
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="password"
                        className="form-control"
                        id="inputRePassword"
                        {...register("rePassword")}
                        placeholder="Confirm Password"
                      />
                    </div>
                  </div>
                  {watch("rePassword") !== watch("password") &&
                  getValues("rePassword") ? (
                    <p>password not match</p>
                  ) : null}

                  <h6 className="mb-2 mt-4">
                    <Icons.BadgeCheckOutline size={20} /> Membership
                  </h6>
                  <div className="row">
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="inputMC">Member Ship</label>

                      <select
                        {...register("membership")}
                        className="form-select"
                        id="membership"
                      >
                        <option value="gold">Gold</option>
                        <option value="diamond">Diamond</option>
                        <option value="premium">Premium</option>
                      </select>
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="inputMC">Customer Type</label>
                      <select
                        {...register("type")}
                        className="form-select"
                        id="type"
                      >
                        <option value="regular">Regular</option>
                        <option value="premium">Premium</option>
                        <option value="vip">VIP</option>
                      </select>
                    </div>
                    <div className="form-group col-4  mb-3">
                      <label htmlFor="inputMC">status</label>
                      <select
                        {...register("status")}
                        className="form-select"
                        id="status"
                        placeholder="status"
                      >
                        <option value="active">active</option>
                        <option value="inactive">inactive</option>
                      </select>
                    </div>
                    {/* Group */}
                    <h6 className="mb-2 mt-4">
                      <Icons.BadgeCheckOutline size={20} /> Group
                    </h6>
                    <div className="row">
                      {/* <div className="form-group col-6 mb-3">
                        <label htmlFor="inputMC">Name</label>

                        <select
                          {...register("group")}
                          className="form-select"
                          id="status"
                        >
                          <option value={""}>Select Group</option>
                          <option value="butex">BUTEX</option>
                        </select>
                      </div> */}
                      <div className="form-group  col-6 mb-3">
                        <label htmlFor="inputMC">Customer Group</label>
                        {/* Hidden input for react-hook-form validation */}
                        <input
                          type="hidden"
                          placeholder="Group"
                          className="form-control"
                          id="p_group"
                          aria-describedby="groupHelp"
                          {...register("group")}
                        />
                        <CustomergroupSelect
                          handleSelectGroup={handleSelectGroup} // Correct prop name
                          group={watch("group")} // Selected group value
                          setValue={setValue}
                        />
                      </div>
                      <div className="form-group col-6  mb-3">
                        <label htmlFor="inputMC">Batch</label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("batch")}
                          placeholder="Batch"
                        />
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-dark col-4">
                    <Icons.SaveOutline /> Customer
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default UpdateCustomer;
